import { Outlet } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { JobCatalogRootPageDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/job_catalog/lib/EmployeesCollectionsBootstrap'
import PageLoading from 'modules/layout/components/Page/Loading'

const Container = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const { data, loading: loadingRootPage } = useQuery(JobCatalogRootPageDocument, {
    variables: { companyId },
  })

  const canSeeJobCatalog = data?.jobCatalog._policies?.seeJobCatalog?.can ?? false
  const canManageCompetencies = data?.competencies._policies?.competenciesManage?.can ?? false
  const canSeeAggregatedInfo =
    data?.employees._policies?.employeeSeeAggregatedPersonalInfo?.can ?? false

  if (loadingRootPage) {
    return (
      <Box width="full" height="full" justifyContent="center" alignItems="center">
        <PageLoading />
      </Box>
    )
  }

  return (
    <AuthorizeUser authorizeFn={() => canSeeJobCatalog}>
      <Outlet context={{ canManageCompetencies, canSeeAggregatedInfo }} />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
